import {
  IsUUID,
  IsNumber,
  IsEnum,
  IsOptional,
  IsDateString,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

import {
  FinancialsResponseInterface,
  FinancialsStatus,
} from '../../interface/financials/financials-response.interface';

import { MiniUsersDto } from '../users/users.dto';

export class FinancialsDto implements FinancialsResponseInterface {

  @IsUUID()
  id!: string;

  @Type(() => Number)
  @IsNumber({ maxDecimalPlaces: 2 })
  annual_sales_target!: number;

  @IsEnum(FinancialsStatus)
  status!: FinancialsStatus;

  @IsOptional()
  @IsDateString()
  created_at!: string | null;

  @IsOptional()
  @IsDateString()
  updated_at!: string | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  created_by!: MiniUsersDto | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  updated_by!: MiniUsersDto | null;
}